// conductor-mcp · conductor b6837825 (main) · origin: dev-mcp · domain: moms · body 12e48874704e
// generated by pbo-conductor — 입고작업 2.0 (gl17)
// conductor-build: b683782 2026-11-03T04:23:13.900Z · pbo-core 0.8.7
// dev 위치: pages/global/inboundWorkV2
// 데이터 seam: useGlobalInboundWork — TODO(dev): 목데이터를 이 훅으로 교체
//
// 그룹 규격 — 이 화면이 쓰는 공통 조합의 계약(컨덕터 소유).
//   이 값을 벗어나면 컨덕터 데모와 어긋납니다. 규격을 바꾸려면 컨덕터에서 바꾸세요.
//   ⚠️ 그룹은 화면마다 사본으로 나갑니다 — 여기서 고쳐도 다른 화면은 바뀌지 않습니다.
//   titleRow #0d760c
//     · title(제목) — 자유 입력
//     · backRoute(뒤로가기 라우트) — 자유 입력
//     · notice(제목 옆 안내 문구) — 자유 입력
//     · stickyTop(스티키 멈춤 위치(px)) 제한 없음 [기본 12]
//     · buttonSize(타이틀 버튼 크기) = S | M | L [기본 L]
//     · 제목 옆 컨트롤과 우측 액션은 자리를 섞지 않는다 — 컨텍스트(센터·뷰)는 제목 옆, 행위는 우측 끝
//   tableGroup #7b6f57
//     · pagerVariant(페이저 표기) = paged | range [기본 paged]
//     · pager(페이저 노출) = 켬 | 끔 [기본 true]
//     · listSearch(목록 검색 노출) = 켬 | 끔 [기본 true]
//     · pagerSizeChanger('몇개씩' 노출) = auto | hide [기본 auto]
//     · rightFirst(화면 우측 요소를 표준 앞에) = 켬 | 끔 [기본 false]
//     · leadColumns(선두 컬럼) = 체크박스 → No | No | 없음 [기본 체크박스 → No]
//     · checkboxWidth(체크박스 폭) 제한 없음 [기본 48px]
//     · noWidth(No 폭) 제한 없음 [기본 48px]
//     · 값·말줄임 짤림 금지 — 컬럼 폭은 콘텐츠 맞춤
//     · 엑셀 다운로드는 exportColumns(한글 헤더) 지정
//
import { core } from '@musinsa/pbo-core'
import { pboLogisticsTheme } from '@musinsa/pbo-core/theme'
import '@musinsa/pbo-core/tokens.css'
import '@musinsa/pbo-core/styles.css'
import '@musinsa/pbo-core/fonts.css'
import './screenShell.css'
import { wiring } from './wiring'
import { type ComponentProps, type ReactNode, useEffect, useMemo, useRef, useState } from 'react'
import { VideoCameraOutlined } from '@ant-design/icons'
import { usePageHeaderSticky } from './pageHeaderSticky'

/** 배선 계약(문서 50) — wiring.ts(개발자 소유)가 이 타입을 채운다. 이름은 노드 id·상수명에서 기계적으로 나온다.
 *  화면(이 파일)은 재핸드오프 때 통째로 덮어쓴다 — 계약이 바뀌면 dev tsc 가 wiring.ts 의 그 자리를 가리킨다. */
export type Row = Record<string, unknown>
/** 표 슬롯 인자 — filters = 같은 화면 조회영역 값(키 = filterKey/노드 id) · pager = 액션바 페이저(page 1부터, size). 없는 화면은 undefined.
 *  모달 안 후보 표는 filters = 모달 [조회]가 적용한 조건(__applied: true 가 있으면 눌렀음, {} 이면 아직) · target = 그 모달을 연 셀(행·칸). */
export type RowsQuery = { filters?: Record<string, unknown>; pager?: { page: number; size: number }; target?: CellTarget; meta?: Record<string, unknown> } // meta = 모달 열림 페이로드(국가 등 — 한 모달을 여러 행이 공유할 때)
/** 액션 슬롯 인자 — selected = 같은 core.TableSelectionScope 안 표의 선택 행(체크박스). 선택 표가 없는 화면은 빈 배열. */
export type ActionCtx = { selected: Row[]; visible?: Row[]; form?: FormState; picked?: Row[]; target?: CellTarget; files?: MediaFile[]; value?: string; meta?: Record<string, unknown> } // selected = 체크 선택 행 · visible = 목록 검색 뒤 화면에 보이는 행(표가 여럿이면 마지막 표, 검색칸 없는 화면은 없음) · form = 확인을 누른 모달의 폼 값(폼 스토어가 있는 모달만) · value = Enter 로 확정한 입력 값(<입력>_enter 슬롯만)
/** 폼 버스 상태(모달·카드의 입력 값). 조건(hideWhen 등)은 wiring.form.<store> 가 덮어쓴 유효 상태를 본다. */
export type FormState = Record<string, unknown>
/** 선택지(옵션) — value 는 API/코드 값, label 은 표시 문구. 조회영역·모달 셀렉트/라디오는 숫자 value 도 쓴다. */
export type Option = { value: string | number; label: string }
/** 편집 셀 셀렉트의 선택지 — DS 셀 계약(variantProps.options)이 value 를 문자열로만 받는다. */
export type CellOption = { value: string; label: string }
/** 셀이 연 모달의 대상(2026-09-30) — rowKey = 그 행의 key(배열 인덱스 또는 배선이 실은 key) · dataIndex = 연 칸 · row = 그 행 · value = 미디어 셀 값(개수). 헬퍼·미디어 모달 슬롯의 ctx.target. */
export type CellTarget = { rowKey: string; dataIndex: string; row: Row; value?: unknown }
/** 미디어 모달 파일(DS core.MediaManager 계약 — 이름·썸네일뿐이라 서버 파일은 배선이 이름으로 잇는다). 헬퍼·미디어 모달 슬롯의 ctx.files. */
export type MediaFile = { name: string; thumb?: string }
/** 표 컬럼 배치(2026-10-21) — DS core.Table 의 제어형 prop 그대로. 컬럼 id = dataIndex(재핸드오프로 dataIndex 가 바뀌면 그 컬럼 저장값은 무시된다).
 *  순서·너비는 조절한 것만 와도 된다. 초기화는 []/{} (undefined 로 바꾸면 비제어로 돌아가 직전 내부 상태가 남는다). */
export type ColumnLayout = Pick<core.CoreTableProps, 'columnOrder' | 'onColumnOrderChange' | 'columnWidths' | 'onColumnWidthsChange' | 'pinnedColumns' | 'onPinnedColumnsChange' | 'hiddenColumns' | 'onHiddenColumnsChange'>
export type Wiring = {
  /** 표 데이터 — 인자는 데모 목데이터(자리 표시)와 조회 조건·페이저. 컴포넌트 본문 첫머리에서 항상 같은 순서로 불리므로 안에서 조회 훅을 써도 된다.
   *  배열을 돌려주면 클라이언트 페이징(데모와 같음), { rows, total } 을 돌려주면 서버 페이징(표는 그대로 그리고 카운트·페이저는 total). */
  rows: { ROWS: (demo: Row[], q: RowsQuery) => Row[] | { rows: Row[]; total?: number; loading?: boolean } }
  /** 동작 — 조회(search)·버튼·확인창·모달 확인·편집 셀·행 버튼. 실패는 throw(확인창·모달이 열린 채 남는다). 성공 토스트·닫기는 생성본이 한다. */
  actions: { gl17SaveButton: (ctx: ActionCtx) => void | string | false | Promise<void | string | false>; gl17RecordStartButton: (ctx: ActionCtx) => void | string | false | Promise<void | string | false>; gl17RecordStopButton: (ctx: ActionCtx) => void | string | false | Promise<void | string | false>; gl17InvoiceInput_enter: (ctx: ActionCtx) => void | string | false | Promise<void | string | false> }
  /** 요청 진행 중 여부(React 훅) — true 면 선택 게이트 버튼(확정·삭제·저장 등)이 잠긴다. 선택 게이트 버튼이 매 렌더 부르므로 안에서 훅을 써도 된다(예: react-query useIsMutating() > 0). 없으면 잠그지 않는다. */
  useBusy?: () => boolean
  /** 액션 슬롯 실패 기록(슬롯 이름 · 원인) — 모니터링·토스트 등. 없으면 생성본이 다시 던져 미처리 거부로 올린다(콘솔엔 브라우저가 찍는다). */
  onActionError?: (slot: string, error: unknown) => void
  /** 표 컬럼 가공(키 = 표 노드 id) — 플래그 열 추가·제목 치환 등 정의 자체를 바꾼다. 배치(순서·너비·고정·숨김)는 columnLayout. 메모돼 표 상태가 유지된다. */
  columns?: { gl17ScanTable?: (columns: core.CoreColumnType[]) => core.CoreColumnType[] }
  /** 표 그룹 문구(키 = 표 그룹 노드 id) — 카운트 라벨("전체"→"조회" 등)·빈 표 문구. 없으면 데모 문구. */
  tableText?: { gl17TableGroup?: { totalLabel?: string; emptyText?: string } }
  /** 표 위 안내 자리(키 = 표 그룹 노드 id) — 조회 결과 안내(건수 초과·경고)를 ReactNode 로. 없으면 비어 있다. */
  feedback?: { gl17TableGroup?: ReactNode }
  /** 표 체크 선택이 바뀔 때 — 상세 표가 선택을 따라가는 화면(마스터-디테일)에서 배선이 그 키로 상세를 조회한다.
   *  선택이 있는 스코프만 알린다(위아래 표에서 빈 스코프가 덮지 않게). 액션 슬롯의 ctx.selected 와 같은 값이다.
   *  scope = **그 선택이 어느 표 그룹의 것인지**(그룹 노드 id). 위아래 표가 있는 화면은 이것으로 갈라 둔다 —
   *  선택을 **푼** 신호는 rows 가 빈 배열이라 행만 보고는 어느 표인지 알 수 없다(2026-09-21 est01). */
  onSelect?: (rows: Row[], scope: string) => void
  /** 화면 입력 값(2026-09-30) — 조회영역·모달 폼 **밖** 입력(스캔 입력·스위치·셀렉트·수기입력 칸). 슬롯을 주면 **배선이 값을 쥔다**(옛 손코드의 상태:
   *  세션/URL 복원 · 다른 동작이 칸을 채움 · 처리 뒤 비움). 슬롯은 함수다 — 컴포넌트 첫머리에서 매 렌더 같은 순서로 불리므로 안에서 훅(useState 등)을 써도 된다.
   *  { value, onChange } 를 돌려준다. 없으면 뷰가 데모처럼 자체 상태로 그린다. 키 = 노드 id. */
  fields?: { gl17AutoRecordSwitch?: () => { value: boolean; onChange: (v: boolean) => void }; gl17SecondsInput?: () => { value: string; onChange: (v: string) => void }; gl17WidthInput?: () => { value: string; onChange: (v: string) => void }; gl17HeightInput?: () => { value: string; onChange: (v: string) => void }; gl17InvoiceInput?: () => { value: string; onChange: (v: string) => void } }
  /** 문구(2026-10-01) — 실제 조회 조건 등 dev 상태로 채우는 안내 문구. 빈 문자열이면 그리지 않는다(없으면 데모 문구). 매 렌더 불리므로 훅 가능. 키 = 노드 id. */
  texts?: { /** 첨부 대기 건수 — 사진 n장 · 영상 n개 · 업로드 중 n건 */ gl17AttachText?: () => string; /** 직전 처리 송장(원본송장) — '원본송장 ' + ORG_TRS_INVOICE, 없으면 '원본송장 없음' */ gl17OrgInvoiceText?: () => string; /** 스캔 판정 결과 — 정상·수량상이·이형·초기화·재출력·임의 합포건·송장 미매칭 + 서버 안내 문구 */ gl17ResultText?: () => string }
  /** 검수 녹화 카메라(2026-10-01) — 주면 DS 요소 대신 같은 모양(RecordingView)으로 그려 미리보기·촬영을 배선이 쥔다. 매 렌더 불리므로 안에서 훅(녹화 훅)을 써도 된다.
   *  preview = 미리보기 칸에 덮을 노드(<video> 등, 칸 크기로 잘린다) · recording = 녹화 중 표시(빨간 테두리·REC 경과) · caption = 미리보기 없을 때 문구
   *  files = 촬영 목록 이름 · onCapture = [촬영(캡처)] · onRemoveFile = 목록에서 지우기. 없으면 데모와 같은 DS 요소(촬영은 화면 안 가짜 목록). */
  recording?: { gl17Recording?: () => { preview?: ReactNode; recording?: boolean; caption?: string; files?: string[]; onCapture?: () => void; onRemoveFile?: (index: number) => void } }
  /** 표 컬럼 배치(2026-10-21, LOGISPRD-15649) — 사용자가 바꾼 순서·너비·고정·숨김을 배선이 저장·복원한다(예: 사용자·화주별 서버 저장).
   *  키 = 표 노드 id(재핸드오프로 표가 늘어도 밀리지 않는다). 함수 — 매 렌더 같은 자리에서 불리므로 안에서 저장 훅을 써도 된다.
   *  인자 columns = 그 표에 넘기는 컬럼 정의(정의 순서·기본 fixed) — 콜백은 바뀐 컬럼만 주므로 전체 상태 저장·고정 해제 복원에 쓴다.
   *  표에 따라 렌더마다 새 배열이다(본문 상수) — effect·memo 의존성에는 배열 대신 내용(dataIndex·fixed 목록)을 쓴다.
   *  없거나 그 표 키가 없으면 종전대로 표 내부 상태(저장 안 함). */
  columnLayout?: { "gl17ScanTable"?: (columns: core.CoreColumnType[]) => ColumnLayout }
}
/** 뷰가 받는 배선 — 아직 안 채운 슬롯이 있어도 된다(`<View wiring={{}} />` 도 뜬다). 다 채운 모습은 `Wiring`. */
export type WiringInput = Omit<Partial<Wiring>, 'rows' | 'actions'> & { rows?: Partial<Wiring['rows']>; actions?: Partial<Wiring['actions']> }

const renderPboEmpty = () => <core.Empty image={core.Empty.PRESENTED_IMAGE_SIMPLE} description="데이터 없음" />

// 액션 실패 기록 — 슬롯(wiring.ts)이 사용자 안내를 맡고, 생성본은 실패를 버리지 않고 원인과 함께 남긴다.
// 액션 실패 — 사용자 안내는 슬롯(wiring.ts)이 맡는다. 기록 슬롯(wiring.onActionError)이 있으면 거기로 넘기고, 없으면 다시 던져 미처리 거부로 올린다(원인을 버리지 않는다 · console 은 쓰지 않는다: dev no-console).
const reportActionError = (slot: string) => (e: unknown): void => { if (wiring.onActionError) { wiring.onActionError(slot, e); return } throw e }
const COLUMNS: core.CoreColumnType[] = [{"title":"송장","width":150,"dataIndex":"INB_TRS_INVOICE"},{"title":"합포장번호","width":160,"dataIndex":"ORD_CONSOL_NO"},{"title":"출고요청일","width":120,"dataIndex":"OUB_PDATE"},{"title":"단포합포구분","width":120,"dataIndex":"SVC_TYPE"},{"title":"보관구역","width":240,"dataIndex":"INV_TYPE"},{"title":"총 입고 수량","width":120,"align":"right","dataIndex":"TOTAL_QTY"},{"title":"위험물(수량)","width":120,"align":"center","dataIndex":"DANGER"},{"title":"이형여부","width":100,"align":"center","dataIndex":"IS_VARIANT"},{"title":"입고상태","width":110,"dataIndex":"ORD_STATUS"}]
const ROWS_DEMO: Record<string, unknown>[] = [{"INB_TRS_INVOICE":"100000000001","ORD_CONSOL_NO":"ML000000000001","OUB_PDATE":"2026-11-01","SVC_TYPE":"단포","INV_TYPE":"A구역","TOTAL_QTY":"1","DANGER":"N","IS_VARIANT":"N","ORD_STATUS":"입고요청"},{"INB_TRS_INVOICE":"100000000002","ORD_CONSOL_NO":"ML000000000002","OUB_PDATE":"2026-11-01","SVC_TYPE":"합포","INV_TYPE":"B구역","TOTAL_QTY":"3","DANGER":"Y","IS_VARIANT":"N","ORD_STATUS":"입고대기"},{"INB_TRS_INVOICE":"100000000003","ORD_CONSOL_NO":"","OUB_PDATE":"2026-11-02","SVC_TYPE":"합포","INV_TYPE":"C구역(미주 아주 긴 보관구역 이름 예시)","TOTAL_QTY":"12","DANGER":"N","IS_VARIANT":"Y","ORD_STATUS":"입고요청"}]
// TODO(dev): ROWS 행 key — wiring.rows 가 행에 key(BE 행 id)를 실으면 그것이 쓰인다(스프레드가 인덱스를 덮는다). 안 실으면 배열 인덱스라 재조회·페이지 이동 뒤 체크 선택이 다른 행에 붙는다. 행 고유 필드(BE 행 id)를 rowKey 로(컨덕터 표 속성 rowKey 지정 시 자동) — 또는 wiring.rows 가 행에 key 를 실으면 스프레드가 인덱스를 덮어 그 값이 쓰인다.
// 선택 행 브리지 — 액션 슬롯 인자(ctx.selected). 같은 core.TableSelectionScope 안 표의 체크 선택 행(SelBridge 가 채운다). 한 화면에 스코프가 여럿이면 마지막으로 바뀐 스코프의 선택이다.
const selRef: { current: Record<string, unknown>[] } = { current: [] }
const selCtx = (): ActionCtx => ({ selected: selRef.current })

/**
 * 검수 녹화 — 배선이 카메라를 쥘 때(wiring.recording.<id>) DS core.InspectionRecording 과 **같은 마크업·같은 DS 클래스**로 그린다
 *  (PD 2026-10-01 "DS 수정은 없이" — DS 요소는 표시 전용이라 미리보기 스트림·촬영 콜백을 받을 자리가 없다).
 *  preview = 미리보기 노드(배선의 <video>)를 미리보기 칸 위에 덮는다 · files·onCapture·onRemoveFile = 촬영 목록. 슬롯이 없으면 생성본은 DS 요소를 그대로 쓴다.
 */
function RecordingView({ recording = true, resolution, caption = '녹화중 (데모)', capture, captureText = '촬영(캡처)', preview, files = [], onCapture, onRemoveFile }: { recording?: boolean; resolution?: string; caption?: string; capture?: boolean; captureText?: string; preview?: ReactNode; files?: string[]; onCapture?: () => void; onRemoveFile?: (index: number) => void }) {
  // REC 경과 — DS 요소와 같은 표기(MM:SS, 1초 간격). 녹화가 꺼지면 0 으로 돌린다(다음 건은 00:00 부터).
  const [sec, setSec] = useState(0)
  useEffect(() => {
    if (!recording) {
      setSec(0)
      return undefined
    }
    const t = window.setInterval(() => setSec((s) => s + 1), 1000)
    return () => window.clearInterval(t)
  }, [recording])
  const mm = String(Math.floor(sec / 60)).padStart(2, '0')
  const ss = String(sec % 60).padStart(2, '0')
  return (
    <div className="pbo-inspection-recording">
      <div className={recording ? 'pir-preview recording' : 'pir-preview'}>
        <VideoCameraOutlined />
        <span>{caption}</span>
        {preview ? <div style={{ position: 'absolute', inset: 0, borderRadius: 'inherit', overflow: 'hidden' }}>{preview}</div> : null}
        {recording ? <i className="pir-rec">REC {mm}:{ss}</i> : null}
      </div>
      {resolution ? <div className="pir-meta">{resolution}</div> : null}
      {capture ? (
        <>
          <core.Button block className="pir-capture" onClick={onCapture}>
            {captureText}
          </core.Button>
          <div className="pir-files-label">파일</div>
          <div className="pir-files">
            {files.map((name, i) => (
              <core.Tag key={`${name}-${i}`} closable onClose={() => onRemoveFile?.(i)}>
                {name}
              </core.Tag>
            ))}
          </div>
        </>
      ) : null}
    </div>
  )
}

/** 표 카운트 — 같은 core.TableSelectionScope 안 표의 선택 개수를 '선택 N / 전체' 로 함께 그린다(데모 TableStatRender 와 같은 규약). 스코프 밖이면 전체만. */
function SelStat(props: ComponentProps<typeof core.TableStat>) {
  const n = core.useTableSelectionCount()
  return <core.TableStat {...props} selectedCount={n && n > 0 ? n : undefined} />
}

/**
 * 선택 행 브리지(문서 50 슬롯 2차) — 같은 core.TableSelectionScope 안 표의 선택 행을 모듈 변수 selRef 로 흘려 보낸다.
 * 액션 슬롯이 ctx.selected 로 받고, 배선이 wiring.onSelect 로 같은 값을 구독한다(상세 표가 선택을 따라가는 화면).
 *
 * 한 화면에 스코프가 여럿이면(위아래 표) **선택이 있는 스코프만** selRef 를 쓴다 — 선택 표가 없는 스코프가
 * 빈 배열로 덮으면 다른 표의 선택이 사라진다(2026-09-19 gl11 위아래 표에서 발견).
 *
 * scope = 이 스코프를 연 그룹 노드 id. 선택을 **푼** 신호는 rows 가 빈 배열이라 행만 보고는 어느 표인지
 * 알 수 없다 — 배선이 위아래를 갈라 두려면 이 값이 있어야 한다(2026-09-21 est01).
 */
function SelBridge({ scope }: { scope: string }) {
  const s = core.useTableSelection()
  const rows = s?.rows
  const owned = useRef(false)
  useEffect(() => {
    if (rows?.length) {
      owned.current = true
      selRef.current = rows
      wiring.onSelect?.(rows, scope)
    } else if (owned.current) {
      owned.current = false
      selRef.current = []
      wiring.onSelect?.([], scope)
    }
    return () => { // 언마운트·스코프 이탈 때 비운다(모듈 변수라 다음 인스턴스로 새지 않게, #772 봇)
      if (!owned.current) return
      owned.current = false
      selRef.current = []
    }
  }, [rows, scope]) // scope 는 그룹 id 리터럴이라 실제로 안 바뀌지만 exhaustive-deps 규칙상 넣는다(moms-fe #787 봇)
  return null
}

// 표 슬롯 미지정 기본값 — 데모 목데이터를 그대로 그린다(wiring.rows 를 안 주거나 그 표만 비웠을 때).
const keepDemoRows = (demo: Row[]): Row[] => demo
export default function InboundWorkV2Page() {
  const hdrgl17Title_titleRowDef = usePageHeaderSticky()
  const fldw_gl17AutoRecordSwitch = wiring.fields?.gl17AutoRecordSwitch ? wiring.fields.gl17AutoRecordSwitch() : undefined // 스위치 'gl17AutoRecordSwitch' 값 — wiring.fields 슬롯(훅 가능). 있으면 배선이 값을 쥔다
  const [stGl17AutoRecordLocal, setStGl17AutoRecordLocal] = useState(false) // 토글 상태(스토어 키 'gl17AutoRecord')
  const stGl17AutoRecord = fldw_gl17AutoRecordSwitch ? fldw_gl17AutoRecordSwitch.value : stGl17AutoRecordLocal
  const setStGl17AutoRecord = (next: boolean) => { if (fldw_gl17AutoRecordSwitch) fldw_gl17AutoRecordSwitch.onChange(next); else setStGl17AutoRecordLocal(next) }
  const rec_gl17Recording = wiring.recording?.gl17Recording ? wiring.recording.gl17Recording() : undefined // 검수 녹화 — 배선의 카메라·촬영(있으면 RecordingView, 없으면 DS 요소)
  const fldw_gl17SecondsInput = wiring.fields?.gl17SecondsInput ? wiring.fields.gl17SecondsInput() : undefined // 입력 'gl17SecondsInput' 값 — wiring.fields 슬롯(훅 가능). 있으면 배선이 값을 쥔다
  const [stGl17SecondsLocal, setStGl17SecondsLocal] = useState('') // 토글 상태(스토어 키 'gl17Seconds')
  const stGl17Seconds = fldw_gl17SecondsInput ? fldw_gl17SecondsInput.value : stGl17SecondsLocal
  const setStGl17Seconds = (next: string) => { if (fldw_gl17SecondsInput) fldw_gl17SecondsInput.onChange(next); else setStGl17SecondsLocal(next) }
  const fldw_gl17WidthInput = wiring.fields?.gl17WidthInput ? wiring.fields.gl17WidthInput() : undefined // 입력 'gl17WidthInput' 값 — wiring.fields 슬롯(훅 가능). 있으면 배선이 값을 쥔다
  const [stGl17WidthLocal, setStGl17WidthLocal] = useState('') // 토글 상태(스토어 키 'gl17Width')
  const stGl17Width = fldw_gl17WidthInput ? fldw_gl17WidthInput.value : stGl17WidthLocal
  const setStGl17Width = (next: string) => { if (fldw_gl17WidthInput) fldw_gl17WidthInput.onChange(next); else setStGl17WidthLocal(next) }
  const fldw_gl17HeightInput = wiring.fields?.gl17HeightInput ? wiring.fields.gl17HeightInput() : undefined // 입력 'gl17HeightInput' 값 — wiring.fields 슬롯(훅 가능). 있으면 배선이 값을 쥔다
  const [stGl17HeightLocal, setStGl17HeightLocal] = useState('') // 토글 상태(스토어 키 'gl17Height')
  const stGl17Height = fldw_gl17HeightInput ? fldw_gl17HeightInput.value : stGl17HeightLocal
  const setStGl17Height = (next: string) => { if (fldw_gl17HeightInput) fldw_gl17HeightInput.onChange(next); else setStGl17HeightLocal(next) }
  const txt_gl17AttachText = wiring.texts?.gl17AttachText ? wiring.texts.gl17AttachText() : "첨부 대기 사진 0장 · 영상 0개" // 첨부 대기 건수 — 사진 n장 · 영상 n개 · 업로드 중 n건 — wiring.texts 슬롯(훅 가능). 빈 문자열이면 그리지 않는다
  const fldw_gl17InvoiceInput = wiring.fields?.gl17InvoiceInput ? wiring.fields.gl17InvoiceInput() : undefined // 스캔 입력 'gl17InvoiceInput' — wiring.fields 슬롯(훅 가능). 있으면 배선이 값을 쥔다
  const [fld_gl17InvoiceInput, setFld_gl17InvoiceInput] = useState<string>('') // 슬롯이 없을 때의 뷰 자체 상태(데모와 같음)
  const fldv_gl17InvoiceInput = fldw_gl17InvoiceInput ? fldw_gl17InvoiceInput.value : fld_gl17InvoiceInput
  const fldSet_gl17InvoiceInput = (v: string) => { if (fldw_gl17InvoiceInput) fldw_gl17InvoiceInput.onChange(v); else setFld_gl17InvoiceInput(v) }
  const txt_gl17OrgInvoiceText = wiring.texts?.gl17OrgInvoiceText ? wiring.texts.gl17OrgInvoiceText() : "원본송장 없음" // 직전 처리 송장(원본송장) — '원본송장 ' + ORG_TRS_INVOICE, 없으면 '원본송장 없음' — wiring.texts 슬롯(훅 가능). 빈 문자열이면 그리지 않는다
  const txt_gl17ResultText = wiring.texts?.gl17ResultText ? wiring.texts.gl17ResultText() : "송장을 스캔해 주세요." // 스캔 판정 결과 — 정상·수량상이·이형·초기화·재출력·임의 합포건·송장 미매칭 + 서버 안내 문구 — wiring.texts 슬롯(훅 가능). 빈 문자열이면 그리지 않는다
  const ROWS_R = (wiring.rows?.ROWS ?? keepDemoRows)(ROWS_DEMO, { filters: undefined, pager: undefined }) // 표 데이터 — wiring.ts 슬롯(인자 = 데모 목데이터·조회 조건(모달 표는 모달 [조회] 적용 조건)·페이저)
  const ROWS = Array.isArray(ROWS_R) ? ROWS_R : ROWS_R.rows
  const ROWS_TOTAL = Array.isArray(ROWS_R) ? ROWS.length : (ROWS_R.total ?? ROWS.length)
  const COLUMNS_FN = wiring.columns?.gl17ScanTable // 컬럼 가공(플래그·열 추가) — wiring.columns 슬롯. 배치는 columnLayout
  const COLUMNS_W = useMemo(() => (COLUMNS_FN ? COLUMNS_FN(COLUMNS) : COLUMNS), [COLUMNS_FN])
  const ROWS_CL = wiring.columnLayout?.gl17ScanTable?.(COLUMNS_W) // 컬럼 배치(순서·너비·고정·숨김) — 없으면 표 내부 상태
  useEffect(() => {
    document.body.classList.add('pbo-screen-portal')
    const hadFontsPortals = document.body.classList.contains('pbo-fonts-portals')
    if (!hadFontsPortals) document.body.classList.add('pbo-fonts-portals')
    return () => { document.body.classList.remove('pbo-screen-portal'); if (!hadFontsPortals) document.body.classList.remove('pbo-fonts-portals') }
  }, [])
  return (
    <core.ConfigProvider theme={pboLogisticsTheme} renderEmpty={renderPboEmpty}>
      <div className="pbo-core-screen pbo-screen-shell pbo-fonts">
        {/* #gl17Page InboundWorkPage */}
        <core.Flex vertical gap={16} align="stretch">
          {/* #workspaceTab WorkspaceTab */}
          <core.WorkspaceTab style={{ margin: "-24px -24px 0px -24px" }} activeLabel="입고작업 2.0" />
          {/* ▼ 그룹 cmp.TitleRow #gl17Title — 구조·배치는 컨덕터 그룹 정의 소유(파일 머리 '그룹 규격'). 안의 요소를 다른 조합(DS 옛 통짜 포함)으로 바꾸지 말고 배선만 붙인다 */}
          {/* #gl17Title:titleRowDef TitleRow */}
          <core.Flex gap={8} justify="space-between" align="center" ref={hdrgl17Title_titleRowDef.ref} className={`dev-page-header-wrap pin${hdrgl17Title_titleRowDef.isSticky ? ' sticky' : ''}`} style={{ flexDirection: "row", justifyContent: "space-between", alignItems: "center", height: 'auto', minHeight: 40, top: 'calc(12px - var(--pbo-page-header-scroller-pad, 0px))', ['--pbo-page-header-bleed-top' as string]: '36px' }}>
            {/* #gl17Title:pageTitle PageTitle */}
            <core.Typography.Title level={4} style={{ margin: 0, whiteSpace: 'pre-line' }}>입고작업 2.0</core.Typography.Title>
            {/* #gl17Title:titleRight TitleRight */}
            <core.Flex gap={16} align="center">
              {/* #gl17TitleButtons TitleButtons */}
              <core.Flex gap={8} align="center">
                {/* #gl17SaveButton SaveButton */}
                <core.Button type="primary" size="large" onClick={() => { const okMsg = "첨부를 저장했습니다."; Promise.resolve(wiring.actions?.gl17SaveButton?.(selCtx())).then((r) => { if (r !== false) core.message.success(typeof r === 'string' ? r : okMsg); }, reportActionError("gl17SaveButton")) }}>저장</core.Button>
              </core.Flex>
            </core.Flex>
          </core.Flex>
          {/* ▲ 그룹 cmp.TitleRow #gl17Title 끝 */}
          {/* #gl17Body WorkBody */}
          <core.Flex gap={16} align="stretch">
            {/* #gl17CameraCol CameraColumn */}
            <core.Flex style={{ width: 360, minWidth: 360 }} vertical gap={0} align="stretch">
              {/* #gl17CameraCard CameraCard */}
              <core.Card>
                <div className="pbo-filter-collapse-open">
                  {/* #gl17CameraTitleRow CameraTitleRow */}
                  <core.Flex gap={8} justify="space-between" align="center">
                    {/* #gl17CameraTitle CameraTitle */}
                    <core.Typography.Text strong>입고 녹화</core.Typography.Text>
                    {/* #gl17AutoRecordSwitch AutoRecordSwitch */}
                    <core.Switch size="small" label="자동녹화" checked={stGl17AutoRecord} onChange={setStGl17AutoRecord} />
                  </core.Flex>
                  {/* #gl17Recording InspectionRecording */}
                  {rec_gl17Recording ? (
                    <RecordingView recording={rec_gl17Recording.recording ?? false} resolution="1280 × 720" capture caption={rec_gl17Recording.caption ?? "카메라 대기"} preview={rec_gl17Recording.preview} files={rec_gl17Recording.files} onCapture={rec_gl17Recording.onCapture} onRemoveFile={rec_gl17Recording.onRemoveFile} />
                  ) : (
                    <core.InspectionRecording recording={false} resolution="1280 × 720" caption="카메라 대기" capture />
                  )}
                  {/* #gl17RecordOptions RecordOptions */}
                  <core.Flex gap={12} align="center" wrap>
                    {/* #gl17SecondsLabel SecondsLabel */}
                    <core.Typography.Text>녹화시간(초)</core.Typography.Text>
                    {/* #gl17SecondsInput SecondsInput */}
                    <core.Input placeholder="0" value={stGl17Seconds} onChange={(e) => setStGl17Seconds(e.target.value)} style={{ width: '100%', maxWidth: 80, minWidth: Math.min(80, 240) }} />
                    {/* #gl17ResolutionLabel ResolutionLabel */}
                    <core.Typography.Text>해상도</core.Typography.Text>
                    {/* #gl17WidthInput WidthInput */}
                    <core.Input placeholder="1280" value={stGl17Width} onChange={(e) => setStGl17Width(e.target.value)} style={{ width: '100%', maxWidth: 90, minWidth: Math.min(90, 240) }} />
                    {/* #gl17ResolutionX ResolutionX */}
                    <core.Typography.Text>×</core.Typography.Text>
                    {/* #gl17HeightInput HeightInput */}
                    <core.Input placeholder="720" value={stGl17Height} onChange={(e) => setStGl17Height(e.target.value)} style={{ width: '100%', maxWidth: 90, minWidth: Math.min(90, 240) }} />
                  </core.Flex>
                  {/* #gl17CaptureButtons CaptureButtons */}
                  <core.Flex gap={8} align="center">
                    {/* #gl17RecordStartButton RecordStartButton */}
                    <core.Button onClick={() => { const okMsg = "녹화를 시작했습니다."; Promise.resolve(wiring.actions?.gl17RecordStartButton?.(selCtx())).then((r) => { if (r !== false) core.message.success(typeof r === 'string' ? r : okMsg); }, reportActionError("gl17RecordStartButton")) }}>녹화 시작</core.Button>
                    {/* #gl17RecordStopButton RecordStopButton */}
                    <core.Button onClick={() => { const okMsg = "녹화를 멈췄습니다."; Promise.resolve(wiring.actions?.gl17RecordStopButton?.(selCtx())).then((r) => { if (r !== false) core.message.success(typeof r === 'string' ? r : okMsg); }, reportActionError("gl17RecordStopButton")) }}>녹화 중단</core.Button>
                  </core.Flex>
                  {/* #gl17AttachText AttachText */}
                  {txt_gl17AttachText ? <core.Typography.Text type="secondary">{txt_gl17AttachText}</core.Typography.Text> : null}
                </div>
              </core.Card>
            </core.Flex>
            {/* #gl17RightCol RightColumn */}
            <core.Flex style={{ flexGrow: 1, flexBasis: 0, minWidth: 0 }} vertical gap={16} align="stretch">
              {/* #gl17InvoiceCard InvoiceCard */}
              <core.Card>
                <div className="pbo-filter-collapse-open">
                  {/* #gl17InvoiceTitle InvoiceTitle */}
                  <core.Typography.Text strong>송장 스캔</core.Typography.Text>
                  {/* #gl17InvoiceRow InvoiceRow */}
                  <core.Flex gap={20} align="center" wrap>
                    {/* #gl17InvoiceField InvoiceField */}
                    <core.Flex gap={16} align="center">
                      {/* #gl17InvoiceLabel InvoiceLabel */}
                      <core.Typography.Text>송장</core.Typography.Text>
                      {/* #gl17InvoiceInput InvoiceInput */}
                      <core.Input placeholder="송장 또는 명령 바코드 스캔 후 Enter" style={{ width: '100%', maxWidth: 320, minWidth: 240 }} value={fldv_gl17InvoiceInput} onChange={(e) => fldSet_gl17InvoiceInput(e.target.value)} onPressEnter={() => { const okMsg = "송장을 처리했습니다."; Promise.resolve(wiring.actions?.gl17InvoiceInput_enter?.({ ...selCtx(), value: fldv_gl17InvoiceInput })).then((r) => { if (r !== false) core.message.success(typeof r === 'string' ? r : okMsg) }, reportActionError("enter")) }} />
                    </core.Flex>
                    {/* #gl17OrgInvoiceText OrgInvoiceText */}
                    {txt_gl17OrgInvoiceText ? <core.Typography.Text type="secondary">{txt_gl17OrgInvoiceText}</core.Typography.Text> : null}
                  </core.Flex>
                  {/* #gl17ResultText ResultText */}
                  {txt_gl17ResultText ? <core.Typography.Text strong>{txt_gl17ResultText}</core.Typography.Text> : null}
                </div>
              </core.Card>
              {/* ▼ 그룹 cmp.TableGroup #gl17TableGroup — 구조·배치는 컨덕터 그룹 정의 소유(파일 머리 '그룹 규격'). 안의 요소를 다른 조합(DS 옛 통짜 포함)으로 바꾸지 말고 배선만 붙인다 */}
              {/* #gl17TableGroup:tableGroupDef TableGroup */}
              <core.TableSelectionScope><SelBridge scope="gl17TableGroup" />
                {/* #gl17TableGroup:tableGroupInner TableGroupInner */}
                <core.Flex vertical gap={8} align="stretch">
                  {wiring.feedback?.gl17TableGroup}
                  {/* #gl17TableGroup:tableHeader TableHeader */}
                  <core.Flex style={{ padding: "4px 0px 4px 0px" }} gap={8} justify="space-between" align="center" className="pbo-v2-actionbar-sticky">
                    {/* #gl17TableGroup:toolbarLeft ToolbarLeft */}
                    <core.Space>
                      {/* #gl17ScanStat ScanStat */}
                      <SelStat total={ROWS_TOTAL} totalLabel={wiring.tableText?.gl17TableGroup?.totalLabel ?? "입고 정보"} />
                    </core.Space>
                    {/* #gl17TableGroup:toolbarRight ToolbarRight */}
                    <core.Space />
                  </core.Flex>
                  {/* #gl17ScanTable ScanTable */}
                  <core.Table columns={COLUMNS_W} dataSource={ROWS.map((r, i) => ({ key: i, ...r }))} loading={Array.isArray(ROWS_R) ? undefined : ROWS_R.loading} locale={wiring.tableText?.gl17TableGroup?.emptyText != null ? { emptyText: wiring.tableText?.gl17TableGroup?.emptyText } : undefined} stickyOffset={104} size="middle" scroll={{ x: 'max-content' }} columnOrder={ROWS_CL?.columnOrder} onColumnOrderChange={ROWS_CL?.onColumnOrderChange} columnWidths={ROWS_CL?.columnWidths} onColumnWidthsChange={ROWS_CL?.onColumnWidthsChange} pinnedColumns={ROWS_CL?.pinnedColumns} onPinnedColumnsChange={ROWS_CL?.onPinnedColumnsChange} hiddenColumns={ROWS_CL?.hiddenColumns} onHiddenColumnsChange={ROWS_CL?.onHiddenColumnsChange} />
                </core.Flex>
              </core.TableSelectionScope>
              {/* ▲ 그룹 cmp.TableGroup #gl17TableGroup 끝 */}
            </core.Flex>
          </core.Flex>
        </core.Flex>
      </div>
    </core.ConfigProvider>
  )
}
